import { useMutation, useQueryClient } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';
import { useSnackbar } from 'notistack';
import { S3_DESTINATIONS_QUERY_KEY } from './useDispatchS3DestinationsQuery';

export const useDeleteDispatchS3DestinationMutation = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (id: number) => {
      await del(`/v1.0/clip-dispatch/s3-destinations/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: S3_DESTINATIONS_QUERY_KEY });
      enqueueSnackbar('S3 destination removed', { variant: 'success' });
    },
    onError: (error: any) => {
      enqueueSnackbar(error?.response?.data?.error || 'Failed to remove S3 destination', { variant: 'error' });
    },
  });
};
